class ImageController {
  constructor(utils) {
    this.utils = utils;
  }

  getImage() {
    if (this.article && this.article.__content) {
      return {
        'background-image': `url(${this.utils.getBase64Src(this.article.__content)})`
      }
    }
  }
}

export default ImageController;



// WEBPACK FOOTER //
// ./client/app/components/content-types/image/image.controller.js